import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "./Sidebar"; // ✅ import Sidebar
import Search from "./Search"; // ✅ import Search component

const UserDashboard = () => {
  const [rootLeader, setRootLeader] = useState(null);
  const [subMembers, setSubMembers] = useState([]);
  const [viewMode, setViewMode] = useState(null); // "direct" | "full" | null
  const [searchResults, setSearchResults] = useState([]); // ✅ for search
  const [user, setUser] = useState(null); // ✅ for sidebar

  // ✅ unchanged fetch function
  const fetchSubMembers = async (Id, returnData = false) => {
    if (!Id) {
      console.error("parentId is undefined!");
      return [];
    }
    try {
      const res = await axios.get(`http://localhost:5000/members/under/${Id}`);
      if (returnData) return res.data;
      setSubMembers(res.data);
      return res.data;
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  // Recursively fetch all descendants
  const fetchFullTeam = async (Id) => {
    const children = await fetchSubMembers(Id, true);
    let all = [...children];
    for (let child of children) {
      const sub = await fetchFullTeam(child._id || child.id);
      all = [...all, ...sub];
    }
    return all;
  };

  // Load initial logged in user
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) {
      setRootLeader(storedUser);
      setUser(storedUser); // ✅ for sidebar
    }
  }, []);

  const handleViewMode = async (mode) => {
    setViewMode(mode);
    setSearchResults([]); // ✅ clear search results if switching mode
    if (!rootLeader) return;
    if (mode === "direct") {
      fetchSubMembers(rootLeader._id || rootLeader.id);
    } else if (mode === "full") {
      const full = await fetchFullTeam(rootLeader._id || rootLeader.id);
      setSubMembers(full);
    }
  };

  if (!rootLeader) {
    return <h3 style={{ textAlign: "center" }}>Loading...</h3>;
  }

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar */}
      <Sidebar user={user} setUser={setUser} />

      {/* Main Content */}
      <div style={{ flex: 1, padding: "30px", textAlign: "center" }}>
        

        {/* ✅ Add Search bar at the top */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px", marginRight: "50px" }}>
          <Search onResults={setSearchResults} />
        </div>

        {/* If search results exist → show them instead of subMembers */}
        {searchResults.length > 0 && (
          <div style={{ marginTop: "20px" }}>
            <h3>🔍 Search Results</h3>
            <table style={{ margin: "0 auto", borderCollapse: "collapse", width: "80%" }}>
              <thead>
                <tr style={{ background: "#f1f1f1" }}>
                  <th style={styles.th}>ID</th>
                  <th style={styles.th}>Name</th>
                  <th style={styles.th}>Cader</th>
                  <th style={styles.th}>Mobile</th>
                </tr>
              </thead>
              <tbody>
                {searchResults.map((m) => (
                  <tr key={m._id}>
                    <td style={styles.td}>{m.Id || m._id}</td>
                    <td style={styles.td}>{m.name}</td>
                    <td style={styles.td}>{m.cader}</td>
                    <td style={styles.td}>{m.mobileNo}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Focus Leader Card */}
        <div style={styles.leaderCard}>
          {console.log(rootLeader)}
          <strong>{rootLeader.referenceNo || rootLeader._id}</strong> - {rootLeader.name} <br />
          <span style={{ fontSize: "14px" }}>{rootLeader.cader || "Leader"}</span>

          {/* Buttons */}
          <div style={{ marginTop: "15px" }}>
            <button
              style={viewMode === "direct" ? styles.activeBtn : styles.btn}
              onClick={() => handleViewMode("direct")}
            >
              Direct Team
            </button>
            <button
              style={viewMode === "full" ? styles.activeBtn : styles.btn}
              onClick={() => handleViewMode("full")}
            >
              Full Team
            </button>
          </div>
        </div>

        {/* Show Team table only when button clicked (if not searching) */}
        {viewMode && searchResults.length === 0 && (
          <div style={{ marginTop: "30px" }}>
            <h3>{viewMode === "direct" ? "Direct Team Members" : "Full Team Members"}</h3>
            {subMembers.length > 0 ? (
              <table style={{ margin: "0 auto", borderCollapse: "collapse", width: "80%" }}>
                <thead>
                  <tr style={{ background: "#f1f1f1" }}>
                    <th style={styles.th}>ID</th>
                    <th style={styles.th}>Name</th>
                    <th style={styles.th}>Cader</th>
                  </tr>
                </thead>
                <tbody>
                  {subMembers.map((m) => (
                    <tr key={m._id}>
                      <td style={styles.td}>{m.Id || m._id}</td>
                      <td style={styles.td}>{m.name}</td>
                      <td style={styles.td}>{m.cader}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p style={{ fontStyle: "italic", color: "gray" }}>No members found</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  th: { border: "1px solid #ccc", padding: "8px" },
  td: { border: "1px solid #ccc", padding: "8px" },
  leaderCard: {
    margin: "20px auto",
    padding: "15px",
    backgroundColor: "#0d6efd",
    color: "white",
    borderRadius: "10px",
    display: "inline-block",
    minWidth: "220px",
    textAlign: "center",
    boxShadow: "0 3px 6px rgba(0,0,0,0.15)",
  },
  btn: {
    marginRight: "10px",
    padding: "6px 12px",
    background: "#6c757d",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
  activeBtn: {
    marginRight: "10px",
    padding: "6px 12px",
    background: "#198754",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
};

export default UserDashboard;
